import React, {FC, useEffect, useState} from "react";
import "../assets/styles/styles.scss";
import ContentVisual from "../components/ContentVisual";
import ContentHeader from "../components/ContentHeader";
import axios from "axios";
import {MenuInterface} from "../model/MenuInterface";
import { handleError } from "../error/ErrorHandler";
import { useParams } from "react-router-dom";
import ShineMyInfoEdit from "../components/ShineMyInfoEdit";
import ShineRequestList from "../components/ShineRequestList";

const MyPage: FC = () => {
    const initMenuInfo: MenuInterface = {
        menuId: 0,
        menuNm: '',
        prtMenuId: 0,
        brdYn: '',
        brdId: 0,
        route: '',
        subList: []
    }

    const { menuId } = useParams();
    const [ menuInfo, setMenuInfo ] = useState(initMenuInfo);
    const [ siblings, setSiblings ] = useState([initMenuInfo]);
    const getMenuInfo = async() => {
        try {
            const res = await axios.get(`/api/menu/one/${menuId}`);
            if (res.data) setMenuInfo(res.data);
        } catch(err) {
            handleError(err);
        }
    };

    const getSiblings = async() => {
        try {
            const res = await axios.get(`/api/menu/siblings/${menuId}`);
            if (res.data) setSiblings(res.data);
        } catch(err) {
            handleError(err);
        }
    }

    useEffect(() => {
        getMenuInfo();
        getSiblings();
    }, [ menuId ]);

    return (
        <div className={'data-catalog-page-wrapper'}>
            <ContentVisual title={menuInfo.menuNm} />
            <ContentHeader subMenuList={siblings} activeMenuId={Number(menuId)} />
            { menuId === '22' && <ShineMyInfoEdit /> }
            { menuId === '23' && <ShineRequestList />}
        </div>
    )
}

export default MyPage;
